import * as ko from 'knockout'
import { Translations } from '~/utils/language'

ko.bindingHandlers.load = {
  init: (element: HTMLElement, valueAccessor, allBindings, viewModel) => {
    element.addEventListener('load', () =>
      valueAccessor().apply(viewModel, [element])
    )
  },
}
ko.bindingHandlers.register = {
  init: (element: HTMLElement, valueAccessor, allBindings, viewModel) => {
    if (typeof valueAccessor() === 'string') {
      viewModel[valueAccessor()] = element
    } else {
      valueAccessor().apply(viewModel, [element])
    }
  },
}
ko.bindingHandlers.i18n = {
  init: (element: HTMLElement, valueAccessor) => {
    const value = valueAccessor()
    if (typeof value === 'object') {
      Object.entries(value).forEach((v) => {
        element.setAttribute(v[0], Translations[v[1] as string])
      })
    } else {
      element.innerText = Translations[value]
    }
  },
}

const INFINITE_SCROLL_THRESHOLD_PX = 100
const INFINITE_SCROLL_THROTTLE_MS = 200

ko.bindingHandlers.infiniteScroll = {
  init: (element: HTMLElement, valueAccessor, _allBindings, viewModel) => {
    const callback = valueAccessor() as () => void
    let throttleTimer: ReturnType<typeof setTimeout> | null = null

    const scrollReference = element.closest<HTMLElement>('.eventFeed')

    const scrollHandler = (): void => {
      if (throttleTimer != null) return
      throttleTimer = setTimeout(() => {
        throttleTimer = null
        let distanceFromBottom: number
        if (scrollReference != null) {
          const rect = scrollReference.getBoundingClientRect()
          distanceFromBottom = rect.bottom - window.innerHeight
        } else {
          const scrollHeight = document.documentElement.scrollHeight
          const scrollTop =
            window.pageYOffset ?? document.documentElement.scrollTop
          const clientHeight = window.innerHeight
          distanceFromBottom = scrollHeight - scrollTop - clientHeight
        }
        if (distanceFromBottom < INFINITE_SCROLL_THRESHOLD_PX) {
          callback.call(viewModel)
        }
      }, INFINITE_SCROLL_THROTTLE_MS)
    }

    window.addEventListener('scroll', scrollHandler, { passive: true })

    ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
      if (throttleTimer != null) clearTimeout(throttleTimer)
      window.removeEventListener('scroll', scrollHandler)
    })
  },
}
